import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import ConsumptionRowWithCO2e from './ConsumptionRowWithCO2e';

const ConsumptionSubentity = ({ subentity, consumption, organisationFacilities, types, usageTypeDetails }) => {
  const options = Object.keys(consumption);

  return options.map((id) => {
    const option = consumption[id]._allFacilities;
    const facilities = Object.keys(consumption[id]).filter((item) => item !== '_allFacilities');
    const usageDetail = [];

    const itemDetails = Object.values(option)[0];

    Object.keys(types).forEach((key) => {
      if (itemDetails[key]) {
        if (usageDetail.length > 0) {
          usageDetail.push(<br />);
        }
        const label = usageTypeDetails && _.find(usageTypeDetails, { type: key })?.displayName;
        const type = types && _.find(types[key], { id: itemDetails[key] });
        const typeName = type && (type.name || type?.priceType);
        usageDetail.push(`${label}: ${typeName}`);
      }
    });

    return (
      <>
        <ConsumptionRowWithCO2e key={crypto.randomUUID()} subentity={subentity} usageDetail={usageDetail} option={option} />
        {organisationFacilities?.length > 1 &&
          facilities.map((facilityID) => {
            const facilityOption = consumption[id][facilityID];
            const facility = _.find(organisationFacilities, { id: facilityID });
            return (
              <ConsumptionRowWithCO2e
                key={crypto.randomUUID()}
                subentity={subentity}
                facility={facility}
                usageDetail={usageDetail}
                option={facilityOption}
              />
            );
          })}
      </>
    );
  });
};

const mapStateToProps = (state, ownProps) => {
  const usageTypeDetails = state?.admin?.adminPortal?.usageTypeDetails;
  const { data, years } = state.consumption;

  const { organisation, facility, metric } = state;

  const { entity, subentity } = ownProps;

  const consumption = data[entity.id][subentity.id];

  return {
    consumption,
    years: years || [],
    usageTypeDetails,
    organisationDetails: organisation?.details,
    organisationMetrics: organisation?.metrics,
    organisationFacilities: facility?.list,
    metrics: metric?.list,
    types: metric?.types,
  };
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ConsumptionSubentity);
